export default __webpack_public_path__ + "static/media/le_lion5.7f374c4b.jpg";